<template>
  <v-form v-model="valid" @submit.prevent="onCreateContact">
    <v-container>
      <v-toolbar color="lime">
        <v-toolbar-title style="color:#0b2b49" text-xs-center>Create New Contact</v-toolbar-title>
      </v-toolbar>

      <v-layout row wrap>
        <v-flex xs12 md4>
          <v-text-field v-model="name" :rules="nameRules" :counter="30" label="Name" required></v-text-field>
        </v-flex>

        <v-flex xs12 md4>
          <v-text-field v-model="email" :rules="emailRules" :counter="30" label="E-mail"></v-text-field>
        </v-flex>
        <v-flex xs12 md4>
          <v-text-field v-model="work_No" :rules="workNoRules" :counter="3" label="Work Number"></v-text-field>
        </v-flex>
        <v-flex xs12 md4>
          <v-select
            v-model="selectedPosition"
            :items="positions"
            :rules="positionRules"
            label="Position"
            required
          ></v-select>
        </v-flex>
        <v-flex xs12 md4>
          <v-select v-model="selectAreas" :items="areas" label="Area" required></v-select>
        </v-flex>
        <v-flex xs12 md4>
          <v-select :items="sectors" v-model="selectSectors" label="Sector"></v-select>
        </v-flex>

        <v-flex xs12 md6>
          <v-text-field v-model="mobile" :rules="mobileRules" :counter="15" label="Mobile (full)"></v-text-field>
        </v-flex>
        <v-flex xs12 md6>
          <v-text-field
            v-model="mobile_short"
            :rules="mobile_shortRules"
            :counter="5"
            label="Mobile (Short)"
          ></v-text-field>
        </v-flex>
        <v-flex xs12 md3>
          <v-text-field v-model="pin1" :rules="pin1Rules" :counter="4" label="Pin 1"></v-text-field>
        </v-flex>
        <v-flex xs12 md3>
          <v-text-field v-model="puk1" :rules="puk1Rules" :counter="8" label="Puk 1"></v-text-field>
        </v-flex>
        <v-flex xs12 md3>
          <v-text-field v-model="pin2" :rules="pin2Rules" :counter="4" label="Pin 2"></v-text-field>
        </v-flex>
        <v-flex xs12 md3>
          <v-text-field v-model="puk2" :rules="puk2Rules" :counter="8" label="Puk 2"></v-text-field>
        </v-flex>
        <v-flex xs12 md3>
          <v-text-field v-model="sim" :rules="simRules" :counter="20" label="Sim Card"></v-text-field>
        </v-flex>
      </v-layout>
      <br />

      <v-layout row>
        <v-flex xs12 sm6 offset-sm5>
          <v-btn class="lime" flat large :disabled="!formIsValid" type="submit">Create Contact</v-btn>
        </v-flex>
      </v-layout>
    </v-container>
  </v-form>
</template>

<script>
export default {
  data: () => ({
    valid: false,
    name: "",
    nameRules: [
      v => !!v || "Name is required",
      v => v.length <= 30 || "Name must be less than 30 characters"
    ],
    email: "",
    emailRules: [
      v => /.+@.+/.test(v) || "E-mail must be valid",
      v => v.length <= 30 || "E-mail must be less than 30 characters"
    ],
    position: null,
    positionRules: [v => !!v || "Position is required"],
    mobile: "",
    mobileRules: [
      v => !!v || "Mobile is required",
      v => v.length <= 15 || "Mobile must be less than 15 characters"
    ],
    mobile_short: "",
    mobile_shortRules: [
      v => !!v || "Mobile short No is required",
      v => v.length <= 5 || "Mobile short No must be less than 5 characters"
    ],
    pin1: "",
    pin1Rules: [v => v.length <= 4 || "Pin 1 must be less than 4 characters"],
    pin2: "",
    pin2Rules: [v => v.length <= 4 || "Pin 2 must be less than 4 characters"],
    puk1: "",
    puk1Rules: [v => v.length <= 8 || "Puk 1 must be less than 8 characters"],
    puk2: "",
    puk2Rules: [v => v.length <= 8 || "Puk 2 must be less than 8 characters"],
    sim: "",
    simRules: [
      v => !!v || "Sim Card No is required",
      v => v.length <= 20 || "Sim Card No must be less than 20 characters"
    ],
    work_No: "",
    workNoRules: [
      // v => !!v || "Work No is required",
      v => v.length <= 3 || "Work No must be less than 3 characters"
    ],
    selectedPosition: "",
    positions: [
      "ΑΠΟΘΗΚΗ",
      "ΕΚΠΑΙΔΕΥΤΗΣ ΠΩΛΗΣΕΩΝ",
      "ΚΕΝΤΡΙΚΑ ΓΡΑΦΕΙΑ",
      "ΛΟΓΙΣΤΗΡΙΟ",
      "ΠΕΡΙΦΕΡΕΙΑΚΟΣ",
      "ΤΟΜΕΑΡΧΗΣ",
      "HOTEL MANAGER",
      "HR",
      "IT",
      "MANAGER",
      "MARKETING",
      "TEAM LEADER"
    ],
    selectAreas: "",  //if i used null, Firebase doesn't create a branch
    selectSectors: "",
    sectors: [
      "BANSKO",
      "ΑΓΙΟΣ ΝΙΚΟΛΑΟΣ",
      "ΑΘΗΝΑ",
      "ΑΜΜΟΥΔΑΡΑ",
      "ΑΝΙΣΑΡΡΑΣ",
      "ΒΟΡΕΙΑ ΚΕΡΚΥΡΑ",
      "ΓΟΥΒΕΣ",
      "ΖΑΚΥΝΘΟΣ-ΚΕΦΑΛΟΝΙΑ",
      "ΘΕΣΣΑΛΟΝΙΚΗ",
      "ΙΕΡΑΠΕΤΡΑ",
      "ΙΞΙΑ",
      "ΚΑΒΡΟΣ",
      "ΚΑΡΔΑΜΕΝΑ",
      "ΚΟΛΥΜΠΙΑ",
      "ΚΩΣ",
      "ΛΙΝΔΟΣ",
      "ΜΑΛΙΑ",
      "ΜΑΣΤΙΧΑΡΙ",
      "ΜΥΚΟΝΟΣ",
      "ΝΟΤΙΑ ΚΕΡΚΥΡΑ",
      "ΠΑΝΟΡΜΟ",
      "ΠΟΡΤΟ ΧΕΛΙ",
      "ΡΕΘΥΜΝΟ",
      "ΣΑΝΤΟΡΙΝΗ",
      "ΣΤΑΛΙΔΑ",
      "ΦΑΛΗΡΑΚΙ",
      "ΧΑΛΚΙΔΙΚΗ",
      "ΧΑΝΙΑ",
      "ΧΕΡΣΟΝΗΣΟΣ"
    ],
    areas: [
      "Extra",
      "ΔΥΤΙΚΗ ΕΛΛΑΔΑ",
      "ΗΡΑΚΛΕΙΟ",
      "ΚΕΝΤΡΙΚΗ-ΒΟΡΕΙΑ ΕΛΛΑΔΑ",
      "ΚΥΠΡΟΣ",
      "ΚΩΣ",
      "ΛΑΣΙΘΙ",
      "ΡΕΘΥΜΝΟ-ΧΑΝΙΑ",
      "ΡΟΔΟΣ"
    ]
  }),
  computed: {
    formIsValid() {
      return (
        this.name !== "" &&
        this.selectedPosition !== "" &&
        (this.work_No !== "" || (this.mobile !== "" && this.mobile_short !== ""))
      );
    }
  },
  methods: {
    onCreateContact() {
      if (!this.formIsValid) {
        return;
      }
      const contactData = {
        name: this.name,
        email: this.email,
        work_No: this.work_No,
        selectedPosition: this.selectedPosition,
        selectAreas: this.selectAreas,
        selectSectors: this.selectSectors,
        mobile: this.mobile,
        mobile_short: this.mobile_short,
        pin1: this.pin1,
        pin2: this.pin2,
        puk1: this.puk1,
        puk2: this.puk2,
        sim: this.sim
      };

      this.$store.dispatch("createContact", contactData);
      this.$router.push("/ContactList");
    }
  }
};
</script>
